import { useState } from "react";

import ListGroup from "react-bootstrap/ListGroup";
import Modal from "react-bootstrap/Modal";
import { format } from "date-fns/format";

import { Alert, Skeleton } from "@evos/components";

import "./pendingConfigs.css";

import type { ChargerNode } from "types";

type PendingConfigsProps = {
  loading: boolean,
  pendingConfigsData: Array<ChargerNode["charger_configuration"]> | undefined,
}

export default function PendingConfigs({
  loading,
  pendingConfigsData,
}: PendingConfigsProps) {

  const [ open, setOpen ] = useState(false);
  const [ selectedDataIndex, setSelectedDataIndex ] = useState(0);

  const openModal = (index: number) => {
    setSelectedDataIndex(index);
    setOpen(true);
  };

  const closeModal = () => setOpen(false);

  const allPendingConfigs = pendingConfigsData?.flat();

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZoneAbbrivation = new Intl.DateTimeFormat("en",{timeZone: timezone, timeZoneName:"short"})?.formatToParts()?.find(part => part.type==="timeZoneName")?.value;

  return (
    <div id="PendingConfigs">
      { !loading
        ? (pendingConfigsData?.length ?? 0) > 0
          ? <ListGroup variant="flush">
            {allPendingConfigs?.map((config, index) => (
              <ListGroup.Item 
                key={`${config.serial}-${config.config_key}`} 
                className="pending-config-list-item" 
                style={{cursor: "pointer"}} 
                onClick={() => openModal(index)}
              >
                <p className="mb-1"><b>{config.serial} - </b>{config.config_key}</p>
                <p className="mb-1 text-secondary" style={{fontSize: "0.8em"}}>
                  { config.changed_timestamp != null
                    ? `${format(new Date(config.changed_timestamp), "yyyy-MM-dd, HH:mm:ss")} (${timeZoneAbbrivation})`
                    : "Time unknown"
                  }
                </p>
              </ListGroup.Item>
            ))}
          </ListGroup>
          : <Alert variant="info" className="mt-3 mx-3 text-center" message="No config items are pending" />
        : <Skeleton
          width="100%"
          height="120px"
          outerClassName="d-flex p-2"
          innerClassName="mb-1"
          lines={3}
        />
      }
      { 
        (allPendingConfigs != null && (pendingConfigsData?.length ?? 0) > 0) && !loading
          && <Modal show={open} onHide={closeModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title><b>{allPendingConfigs[selectedDataIndex].serial} - </b> {allPendingConfigs[selectedDataIndex].config_key}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{overflow: "auto"}}>
              <p><b>Backend Set Value: </b>{allPendingConfigs[selectedDataIndex].set_value ?? "Unknown"}</p>
              <p><b>Charger Value: </b>{allPendingConfigs[selectedDataIndex].charger_value ?? "Unknown"}</p>
              <p>
                <b>Time of Change: </b> 
                { allPendingConfigs[selectedDataIndex]?.changed_timestamp != null
                  ? `${format(new Date(allPendingConfigs[selectedDataIndex].changed_timestamp), "yyyy-MM-dd, HH:mm:ss")} (${timeZoneAbbrivation})`
                  : "Time unknown"
                }
              </p>
            </Modal.Body>
          </Modal>
      }
    </div>
  );
}